import * as THREE from 'three'
import { ConvexHull } from './convexhull'

//minimum oriented bounding box
// 点群より凸包を求め、凸包を構築する点群の１つ１つの辺の角度

class mobb {

    public computeCorners(points: THREE.Vector2[]) : THREE.Vector2[]
    {
        //凸包を求める
        const convexHullPoints = new ConvexHull().setFromPoints(points);
        if (!convexHullPoints) return [];

        const alignmentPointIndex = this.computeAlignmentPointIndex(convexHullPoints);

        const r = this.computeAlignedBounds(convexHullPoints, alignmentPointIndex);

        const alignedCorners: THREE.Vector2[] = [
            r.min,
            new THREE.Vector2(r.max.x, r.min.y),
            r.max,
            new THREE.Vector2(r.min.x, r.max.y)
        ];
        const center = convexHullPoints[alignmentPointIndex];
        const angleRad = this.computeEdgeAngleRad(convexHullPoints, alignmentPointIndex);

        const translate = new THREE.Matrix3().translate(center.x, center.y);
        const rotate = new THREE.Matrix3().rotate(angleRad);
        const matrix = new THREE.Matrix3().multiplyMatrices(translate, rotate);

        const corners = this.transform(alignedCorners, matrix);
        return corners;
    }

    private computeAlignmentPointIndex(points: THREE.Vector2[]) : number
    {
        let minArea = Number.MAX_SAFE_INTEGER;
        let minAreaIndex = -1;
        for (let i = 0; i < points.length; i++) {
            const box = this.computeAlignedBounds(points, i);
            // 最小領域の算出
            const size = new THREE.Vector2();
            box.getSize(size);
            const area = size.x * size.y;

            if (area < minArea) {
                minArea = area;
                minAreaIndex = i;
            }
        }
        return minAreaIndex;
    }

    // private computeAlignmentPointIndex(points: THREE.Vector2[]) : number 
    // {
    //     let angle = Number.MAX_SAFE_INTEGER;
    //     let result = -1;

    //     for (let i = 1; i <= points.length; i++) {
    //         const p1 = points[i-1];
    //         const p2 = points[i % points.length];
    //         const p3 = points[(i + 1) % points.length];

    //         const v1 = p1.clone().sub(p2).normalize();
    //         const v2 = p3.clone().sub(p2).normalize();

    //         const rad = Math.acos(v1.dot(v2));
    //         const r = Math.abs(rad - (1/2*Math.PI));
    //         if (r < angle) {
    //             angle = r;
    //             result = i % points.length;
    //         }
    //     }

    //     return result;
    // }

    private computeEdgeAngleRad(points: THREE.Vector2[], index: number) : number
    {
        const p0 = points[index];
        const p1 = points[(index + 1) % points.length];
        return -p1.clone().sub(p0).angle();
    }

    private computeAlignedBounds(points: THREE.Vector2[], index: number) : THREE.Box2
    {
        const computeBounds = (points:THREE.Vector2[]) => new THREE.Box2().setFromPoints(points);

        const angleRad = this.computeEdgeAngleRad(points, index);
        const p0 = points[index];
        const mat = this.createTransform(-angleRad, p0);
        const transformedPoints = this.transform(points, mat);
        return computeBounds(transformedPoints);
    }

    private createTransform(angleRad: number, center: THREE.Vector2) : THREE.Matrix3
    {
        const rotate = new THREE.Matrix3().rotate(angleRad);
        const translate = new THREE.Matrix3().translate(-center.x, -center.y);
        return new THREE.Matrix3().multiplyMatrices(rotate, translate);
    }

    private transform(points: THREE.Vector2[], matrix : THREE.Matrix3) : THREE.Vector2[]
    {
        return <THREE.Vector2[]>points.map((p) => p.clone().applyMatrix3(matrix));
    }
}

export { mobb }